import { render, staticRenderFns } from "./OrderFees.vue?vue&type=template&id=10cd5555&scoped=true"
import script from "@/views/OrderFee/OrderFees.ts?vue&type=script&lang=ts&external"
export * from "@/views/OrderFee/OrderFees.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/OrderFee/order_fees.scss?vue&type=style&index=0&id=10cd5555&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd5555",
  null
  
)

export default component.exports